class RedemptionGrid {
	constructor(redemptions) {
		this.redemptions = redemptions;
		
	}


	renderCustomRewards() {
		this.redemptions.forEach((redemption) => {

			if(redemption.id === 646955) {

			$(".loyalty-redemptions").append(
				$("<a>", {
					"data-redemption-option-id" : redemption.id
				}).addClass("swell-redemption-link").addClass("redemption-option").append(
					$("<h3>").addClass("redemption-name").text(redemption.name),
					$("<div>").addClass("redemption-desc").text(redemption.description),
                  	$("<div>").addClass("keep-it-cool-logo").css("background-image", "url("+ redemption.backgroundImageUrl +")"),
                 	$("<div>").addClass("redemption-btn").text("donate")
				)
	
				)
			}
              // change the ID below to the custom reward you want to show
          else if (redemption.id === 771289) {
			$(".loyalty-redemptions").append(
				$("<a>", {
					"data-redemption-option-id" : redemption.id
				}).addClass("swell-redemption-link").addClass("redemption-option").append(
					$("<h3>").addClass("redemption-name").text(redemption.name),
					$("<div>").addClass("redemption-desc").text(redemption.description),
                  	$("<div>").addClass("prm-logo").css("background-image", "url("+ redemption.backgroundImageUrl +")"),
                 	$("<div>").addClass("redemption-btn").text("Redeem")
				)
	
				)
          }
                    else if (redemption.id === 761008) {
			$(".loyalty-redemptions").append(
				$("<a>", {
					"data-redemption-option-id" : redemption.id
				}).addClass("swell-redemption-link").addClass("redemption-option").append(
					$("<h3>").addClass("redemption-name").text(redemption.name),
					$("<div>").addClass("redemption-desc").text(redemption.description),
                  	$("<div>").addClass("prm-logo").css("background-image", "url("+ redemption.backgroundImageUrl +")"),
                 	$("<div>").addClass("redemption-btn").text("11am, 25th March")
				)
	
				)
          }
		})
	}
}

